import { defineComponent as _defineComponent } from 'vue';
import { ref, watch, onMounted } from 'vue';
import { BOverlay } from 'bootstrap-vue';
import round from 'lodash/round';
import { useAxios } from 'composables/useAxios';
import { getModelDiscounts, getStandardDiscounts, getWholesaleDiscounts } from 'public/modules/pricing';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DiscountsBreakdown',
    props: {
        itemType: { default: 'Item' },
        skuPrefix: { default: null },
        modelProductId: { default: null },
        wholesaleProductId: { default: null },
        price: { default: '0.00' }
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const discounts = ref([]);
        const axios = useAxios();
        async function refresh() {
            loading.value = true;
            if (props.skuPrefix !== null) {
                discounts.value = await getStandardDiscounts(props.skuPrefix, props.price);
            }
            else if (props.wholesaleProductId !== null) {
                discounts.value = await getWholesaleDiscounts(props.wholesaleProductId, props.price);
            }
            else if (props.modelProductId !== null) {
                discounts.value = await getModelDiscounts(props.modelProductId, props.price);
            }
            else {
                throw new Error('Either skuPrefix or modelProductId must be provided to DiscountsBreakdown');
            }
            loading.value = false;
        }
        watch(() => props.price, refresh);
        onMounted(refresh);
        return { __sfc: true, props, loading, discounts, axios, refresh, ref, watch, onMounted, BOverlay, round, useAxios, getModelDiscounts, getStandardDiscounts, getWholesaleDiscounts };
    }
});
